// import React, { Component } from 'react'
// import {
//   Link
// } from "react-router-dom";
// export class Navbar extends Component {
  
//   render() {
//     return (
//       <div>
//         <nav className="navbar fixed-top navbar-expand-lg bg-body-tertiary">
//   <div className="container-fluid">
//     <Link className="navbar-brand" to="/">Navbar</Link>
//     <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="/navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//       <span className="navbar-toggler-icon"></span>
//     </button>
//     <div className="collapse navbar-collapse" id="navbarSupportedContent">
//       <ul className="navbar-nav me-auto mb-2 mb-lg-0">
//         <li className="nav-item">
//           <Link className="nav-link" aria-current="page" to="/">Home</Link>
//         </li>
//         <li className="nav-item"><Link className="nav-link" to="/business">Business</Link></li>
//         <li className="nav-item"><Link className="nav-link" to="/entertainment">Entertainment</Link></li>
//         <li className="nav-item"><Link className="nav-link" to="/general">General</Link></li>
//         <li className="nav-item"><Link className="nav-link" to="/health">Health</Link></li>
//         <li className="nav-item"><Link className="nav-link" to="/science">Science</Link></li>
//         <li className="nav-item"><Link className="nav-link" to="/sports">Sports</Link></li>
//         <li className="nav-item"><Link className="nav-link" to="/technology">Technology</Link></li>
        
//         </ul>
//     </div>
//   </div>
// </nav>
//       </div>
//     )
//   }
// }

// export default Navbar



import React, { Component } from 'react';
import { NavLink, Link } from "react-router-dom";
import news from "./news.png" 

export class Navbar extends Component {
  // 1. Define your nav items in an array for the .map() function
  navItems = [
    { path: "/", name: "Home" },
    { path: "/business", name: "Business" },
    { path: "/entertainment", name: "Entertainment" },
    { path: "/general", name: "General" },
    { path: "/health", name: "Health" },
    { path: "/science", name: "Science" },
    { path: "/sports", name: "Sports" },
    { path: "/technology", name: "Technology" },
  ];

  render() {
    return (
      <div>
        <nav className="navbar fixed-top navbar-expand-lg news-navbar">
          <div className="container-fluid px-3 px-lg-4">
            <Link className="navbar-brand" to="/">
            <img src={news} alt="NewsMonkey" className="rounded"/>
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
              <span className="navbar-toggler-icon"></span>
            </button>
            
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                
                {/* 2. Using .map() to loop through the links */}
                {this.navItems.map((item) => (
                  <li className="nav-item" key={item.path}>
                    <NavLink 
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      to={item.path}
                    >
                      {item.name}
                    </NavLink>
                  </li>
                ))}

              </ul>
            </div>
          </div>
        </nav>
      </div>
    )
  }
}

export default Navbar;